class CtaLink extends HTMLElement {
  connectedCallback() {
    const href = this.getAttribute('href');
    const text = this.textContent.trim();

    if (!href || !text) return;

    const container = document.createElement('div');
    container.className = 'custom-blog-button-container';
    container.style.cssText = 'margin:32px 0;display:flex;flex-direction:column;align-items:center;gap:12px;min-height:clamp(40px,calc(2vw + 24px),44px)';

    const button = document.createElement('a');
    button.href = href;
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
    button.textContent = text;

    container.appendChild(button);
    this.replaceWith(container);
  }
}

customElements.define('cta-link', CtaLink);

(function() {
  function convertUtmLinksToButtons() {
    const rteContainer = document.querySelector('div[id*="__main-article"] .rte, article.article .rte, .article--content');
    if (!rteContainer) return;

    rteContainer.removeAttribute("style");

    const links = rteContainer.querySelectorAll('a[href*="utm"]');
    if (links.length === 0) return;

    const replacements = [];

    links.forEach(link => {
      link.removeAttribute("style");

      if (link.closest('.custom-blog-button-container')) return;
      const href = link.getAttribute('href');
      if (!href) return;

      const span = link.querySelector('span');
      const text = span ? span.textContent.trim() : link.textContent.trim();
      if (!text) return;

      const ctaLink = document.createElement('cta-link');
      ctaLink.setAttribute('href', href);
      ctaLink.textContent = text;
      replacements.push({ link, ctaLink });
    });

    replacements.forEach(({ link, ctaLink }) => {
      link.parentNode.replaceChild(ctaLink, link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertUtmLinksToButtons);
  } else {
    convertUtmLinksToButtons();
  }
})();
